import axios from "./index";
import { Backend_Api } from "../config/constant";

export const getMenusForEmployee = async (empId) => {
  try {
    const res = await axios.get(`${Backend_Api}menus/${empId}?&mode=getAllMenus`); //&mode=getAllMenus , &mode=get_assigned_menus
    return res.data || [];
  } catch (err) {
    console.error("❌ Error fetching menus:", err);
    return [];
  }
};
